import Vue from 'vue'
import Vuex from 'vuex'
import loader from '@/loader'

import text from '@/store/Default/text.module'
import form from '@/store/Default/form.module'
import settings from '@/store/Default/settings.module'
import guard from '@/store/Default/guard.module'
import profile from '@/store/Default/profile.module'
import basket from '@/store/Default/basket.module'
import outlet from '@/store/Default/outlet.module'
import order from '@/store/Default/order.module'
import vue from '@/store/Default/vue.module'

loader.initAxios()

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: { text, settings, form, guard, profile, basket, outlet, order, vue }
})

export default store